import React from 'react';

const PrivacyPolicy: React.FC = () => {
    return (
        <div className="container mt-4">
            <h1 className="mb-4">Datenschutzhinweise</h1>

            <h2>Datenschutz-Hinweise für den Webauftritt „Frühe Hilfen / FamilienPlus"</h2>
            <p>
                <em>Angaben nach Art. 12, 13, 14 Datenschutz-Grundverordnung (DSGVO)</em><br />
                <em>Stand: 09.12.2025</em>
            </p>

            <h3>Inhaltsverzeichnis</h3>
            <ol>
                <li><a href="#gegenstand">Gegenstand</a></li>
                <li><a href="#verantwortliche">Name und Kontaktdaten der für die Verarbeitung Verantwortlichen sowie der Datenschutzbeauftragten</a></li>
                <li><a href="#sichtbarkeit">Sichtbarkeit Ihrer Profildaten</a></li>
                <li>
                    <a href="#einzelne-funktionen">Einzelne Funktionen</a>
                    <ol type="a">
                        <li><a href="#darstellung-vermittlung">Darstellung und Vermittlung von Angeboten/Leistungen</a></li>
                        <li><a href="#app-funktionen">App-spezifische Funktionen (nur so weit zutreffend)</a></li>
                    </ol>
                </li>
                <li>
                    <a href="#datenverarbeitung-analyse">Datenverarbeitung zu Analyse-Zwecken</a>
                    <ol type="a">
                        <li><a href="#server-logfiles">Server Log-Files (Web-Oberfläche)</a></li>
                        <li><a href="#nutzungsstatistiken">Nutzungsstatistiken</a></li>
                    </ol>
                </li>
                <li>
                    <a href="#ergaenzende-hinweise">Ergänzende Hinweise zur Bereitstellungspflicht, Rechtsgrundlage, Verarbeitungszwecken, Empfängern und Speicherdauer</a>
                    <ol type="a">
                        <li><a href="#bereitstellungspflicht">Bereitstellungspflicht</a></li>
                        <li><a href="#rechtsgrundlage">Rechtsgrundlage und Nutzungszwecke</a></li>
                        <li><a href="#datenempfaenger">Datenempfänger und Auftragsverarbeiter</a></li>
                        <li><a href="#speicherdauer">Speicherdauer</a></li>
                    </ol>
                </li>
                <li><a href="#ihre-dsgvo-rechte">Ihre Rechte nach der DSGVO</a></li>
                <li><a href="#datensicherheit">Datensicherheit</a></li>
                <li><a href="#aktualitaet">Aktualität und Änderung dieser Datenschutzinformation</a></li>
                <li>
                    <a href="#anhang">Anhang: Begriffserläuterungen und Rechtsgrundlagen</a>
                    <ol type="a">
                        <li><a href="#begriffe">Begriffe</a></li>
                        <li><a href="#rechtsgrundlagen">Rechtsgrundlagen</a></li>
                    </ol>
                </li>
            </ol>

            <h2 id="gegenstand">1. Gegenstand</h2>
            <p>
                Mit diesen Datenschutzhinweisen informieren wir Sie über die Verarbeitung Ihrer personenbezogenen
                Daten durch uns, wenn Sie die Homepage{' '}
                <a href="https://www.familien-plus.de" target="_blank" rel="noopener noreferrer">
                    https://www.familien-plus.de
                </a>{' '}
                und/oder die App „FamilienPlus" aufrufen und nutzen.
            </p>
            <p>
                Diese Datenschutzhinweise gelten einheitlich für die Nutzung der Website www.familien-plus.de sowie
                der App „FamilienPlus". Website und App verwenden identische Datenschutzbestimmungen;
                app-spezifische Besonderheiten sind – soweit zutreffend und in Ziffer 4.2 beschrieben.
            </p>

            <h2 id="verantwortliche">2. Name und Kontaktdaten der für die Verarbeitung Verantwortlichen sowie der Datenschutzbeauftragten</h2>
            <p>
                Verantwortliche Stelle für die Datenverarbeitung auf dieser Website/App ist:
            </p>
            <p>
                Landratsamt Waldshut – Jugendamt (Frühe Hilfen / FamilienPlus)<br />
                Kaiserstraße 110<br />
                79761 Waldshut-Tiengen<br />
                Deutschland
            </p>
            <p>
                Telefon: +49 (0) 7751 / 86-0<br />
                Fax: +49 (0) 7751 / 86-1999<br />
                E-Mail: <a href="mailto:post@landkreis-waldshut.de">post@landkreis-waldshut.de</a>
            </p>
            <p>
                Vertreten durch den Landrat des Landkreises Waldshut, Dr. Martin Kistler.
            </p>

            <h3>Kontakt des Angebots „Frühe Hilfen / FamilienPlus":</h3>
            <p>
                Landratsamt Waldshut – Jugendamt, Frühe Hilfen / FamilienPlus<br />
                Im Wallgraben 38<br />
                79761 Waldshut-Tiengen<br />
                Telefon: +49 (0) 7751 / 86-4343<br />
                E-Mail: <a href="mailto:Fruehe.Hilfen@landkreis-waldshut.de">Fruehe.Hilfen@landkreis-waldshut.de</a>
            </p>

            <h3>Inhaltlich verantwortliche Leitung (fachlich zuständig):</h3>
            <p>
                Heribert Thamm, Amtsleiter Jugendamt<br />
                Landratsamt Waldshut, Kaiserstraße 110, 79761 Waldshut-Tiengen<br />
                Telefon: +49 (0) 7751 / 86-4301<br />
                E-Mail: <a href="mailto:jugendamt@landkreis-waldshut.de">jugendamt@landkreis-waldshut.de</a>
            </p>

            <h3>Datenschutzbeauftragte des Landkreises:</h3>
            <p>
                Landratsamt Waldshut – Datenschutzbeauftragte<br />
                Kaiserstraße 110<br />
                79761 Waldshut-Tiengen<br />
                Telefon: +49 (0) 7751 / 86-7200<br />
                E-Mail: <a href="mailto:datenschutz@landkreis-waldshut.de">datenschutz@landkreis-waldshut.de</a>
            </p>
            <p>
                Der technische Betrieb der Website/App (Hosting, Wartung, Support) erfolgt durch die CloudHaus GmbH
                als Auftragsverarbeiter (siehe Ziffer 6.3).
            </p>

            <h2 id="sichtbarkeit">3. Sichtbarkeit Ihrer Profildaten</h2>
            <p>
                Sofern Sie als Leistungserbringer ein Profil bzw. Angebote auf{' '}
                <a href="https://www.familien-plus.de" target="_blank" rel="noopener noreferrer">
                    https://www.familien-plus.de
                </a>{' '}
                anlegen, können folgende Angaben für andere Besucher der Plattform sichtbar sein (auch ohne
                Registrierung):
            </p>
            <ul>
                <li>Name der Organisation (sofern Organisation)</li>
                <li>Profilbild (sofern hinterlegt)</li>
                <li>Textuelle Profilbeschreibung (sofern hinterlegt)</li>
                <li>Kontakt-E-Mail-Adresse (sofern hinterlegt)</li>
                <li>Webseite (sofern hinterlegt)</li>
                <li>Telefonnummer (sofern hinterlegt)</li>
                <li>Registrierdatum (sofern relevant)</li>
                <li>Weitere freiwillige Angaben</li>
            </ul>

            <h2 id="einzelne-funktionen">4. Einzelne Funktionen</h2>
            <p>
                Nachfolgend erläutern wir den Umgang mit Ihren Daten, wenn Sie einzelne Funktionen der Website{' '}
                <a href="https://www.familien-plus.de" target="_blank" rel="noopener noreferrer">
                    https://www.familien-plus.de
                </a>{' '}
                oder der App „FamilienPlus" nutzen.
            </p>

            <h3 id="darstellung-vermittlung">4.1. Darstellung und Vermittlung von Angeboten/Leistungen</h3>
            <p>
                Die Darstellung und Suche von Angeboten können über Website und App erfolgen; die Datenverarbeitung
                ist identisch.
            </p>
            <p>
                Die Webseite dient der Sichtbarmachung und Vermittlung von Angeboten der Frühen Hilfen, insbesondere
                für Schwangere, (werdende) Eltern und Familien mit Kindern bis drei Jahre im Landkreis Waldshut.
            </p>
            <p>
                Leistungserbringer können ihre Angebote einstellen. Diese Angaben (inkl. Beschreibung) sind für alle
                Besucher der Plattform sichtbar.
            </p>
            <p>
                Sie können die Löschung Ihres Angebots jederzeit beantragen. Nehmen Sie hierzu Kontakt mit dem
                Betreiber der Plattform auf (siehe Ziffer 2).
            </p>
            <p>
                Eine Buchung von Leistungen über unsere Webseite/App erfolgt nicht. Wenn Sie ein Angebot in Anspruch
                nehmen möchten, kontaktieren Sie den Leistungserbringer über die von ihm angegebenen Kanäle (z. B.
                telefonisch oder vor Ort).
            </p>
            <p>
                Bitte nutzen Sie nicht das Kontaktformular der Webseite/App zur Übermittlung sensibler Daten (z. B.
                Gesundheitsdaten), sondern wenden Sie sich direkt an den jeweiligen Leistungserbringer.
            </p>

            <h3 id="app-funktionen">4.2. App-spezifische Funktionen (nur so weit zutreffend)</h3>
            <p>
                Bei Nutzung der App können – abhängig von Geräte- und App-Einstellungen – zusätzlich technische
                Geräte-/App-Informationen (z. B. App-Version, Betriebssystem) verarbeitet werden, um den sicheren
                Betrieb zu gewährleisten.
            </p>
            <p>
                Sofern Push-Benachrichtigungen oder bestimmte Berechtigungen (z. B. Kamera/Dateizugriff) genutzt
                werden, informieren wir hierüber transparent; andernfalls fallen keine zusätzliche App-Daten an.
            </p>

            <h2 id="datenverarbeitung-analyse">5. Datenverarbeitung zu Analyse-Zwecken</h2>

            <h3 id="server-logfiles">5.1. Server Log-Files (Web-Oberfläche)</h3>
            <p>
                Beim Aufruf einzelner Seiten werden in Log-Dateien gespeichert: URL der abgerufenen Seite, Datum und
                Uhrzeit, Fehlermeldungen, Betriebssystem, Browsertyp und die Referrer-URL. Wir speichern dabei auch
                die IP-Adresse.
            </p>
            <p>
                Die Log-File-Daten werden ausschließlich zur Sicherstellung der Funktionsfähigkeit und Sicherheit
                verwendet und nach sieben (7) Tagen gelöscht oder anonymisiert.
            </p>

            <h3 id="nutzungsstatistiken">5.2. Nutzungsstatistiken</h3>
            <p>
                Wir erfassen anonyme Nutzungsstatistiken darüber, welche Funktionen und Seiten wie häufig genutzt
                werden. Es erfolgt keine Zuordnung zu Ihrem Gerät oder Nutzungskonto; es werden keine pseudonymen
                Profile erstellt.
            </p>
            <p>
                Für Nutzungsstatistiken werden keine Drittdienstleister eingesetzt. Die „Do-not-track"-Einstellung
                Ihres Browsers wird respektiert.
            </p>

            <h2 id="ergaenzende-hinweise">6. Ergänzende Hinweise zur Bereitstellungspflicht, Rechtsgrundlage, Verarbeitungszwecken, Empfängern und Speicherdauer</h2>

            <h3 id="bereitstellungspflicht">6.1. Bereitstellungspflicht</h3>
            <p>
                Sie sind nicht verpflichtet, Daten bereitzustellen, wenn Sie die Webseite/App nur besuchen.
                Pflichtangaben in Formularen sind als solche gekennzeichnet.
            </p>

            <h3 id="rechtsgrundlage">6.2. Rechtsgrundlage und Nutzungszwecke</h3>
            <p>
                Zweck der Plattform ist die Information über und Vermittlung von Angeboten der Frühen Hilfen im
                Landkreis Waldshut. Rechtsgrundlage ist die Wahrnehmung einer Aufgabe im öffentlichen Interesse
                (Art. 6 Abs. 1 lit. e DSGVO).
            </p>
            <p>
                Sofern Sie ein Nutzerkonto anlegen, dient die Datenverarbeitung zusätzlich der Durchführung des
                Nutzungsverhältnisses (Art. 6 Abs. 1 lit. b DSGVO).
            </p>

            <h3 id="datenempfaenger">6.3. Datenempfänger und Auftragsverarbeiter</h3>
            <p>
                Innerhalb des Landratsamts erhalten nur fachlich zuständige Stellen Zugriff auf Ihre Daten.
            </p>
            <p>
                Technischer Betrieb/Hosting der Plattform und App erfolgt durch:
            </p>
            <p>
                CloudHaus GmbH<br />
                Sandweg 10<br />
                38524 Sassenburg<br />
                E-Mail: <a href="mailto:info@cloudhaus.io">info@cloudhaus.io</a><br />
                Web: <a href="https://www.cloudhaus.io" target="_blank" rel="noopener noreferrer">www.cloudhaus.io</a>
            </p>
            <p>
                CloudHaus kann Subdienstleister für Hosting/Support einsetzen; dies erfolgt weisungsgebunden als
                Auftragsverarbeitung.
            </p>

            <h3 id="speicherdauer">6.4. Speicherdauer</h3>
            <p>
                Wir speichern personenbezogene Daten nur so lange, wie es für die jeweiligen Zwecke erforderlich ist.
                Profile/Angebote werden mindestens bis zu deren Löschung gespeichert. Darüber hinaus gelten
                gesetzliche Aufbewahrungs- und Verjährungsfristen (§§ 195 ff. BGB).
            </p>

            <h2 id="ihre-dsgvo-rechte">7. Ihre Rechte nach der DSGVO</h2>
            <ul>
                <li>Auskunft (Art. 15 DSGVO)</li>
                <li>Berichtigung (Art. 16 DSGVO)</li>
                <li>Löschung (Art. 17 DSGVO)</li>
                <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
                <li>Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)</li>
                <li>Widerruf erteilter Einwilligungen mit Wirkung für die Zukunft</li>
                <li>Widerspruch gegen Verarbeitungen aus Gründen Ihrer besonderen Situation (Art. 21 DSGVO)</li>
            </ul>
            <p>
                Zuständige Aufsichtsbehörde ist der Landesbeauftragte für den Datenschutz und die Informationsfreiheit
                Baden-Württemberg, Lautenschlagerstraße 20, 70173 Stuttgart, Tel.: +49 (0)711 615541-0, E-Mail:{' '}
                <a href="mailto:poststelle@lfdi.bwl.de">poststelle@lfdi.bwl.de</a>.
            </p>

            <h2 id="datensicherheit">8. Datensicherheit</h2>
            <p>
                Alle von Ihnen persönlich übermittelten Daten werden mit dem allgemein üblichen und sicheren Standard
                TLS (Transport Layer Security) verschlüsselt übertragen. TLS ist ein sicherer und erprobter Standard,
                der z. B. auch beim Onlinebanking Verwendung findet. Sie erkennen eine sichere TLS-Verbindung unter
                anderem an dem angehängten s am http (also https://...) in der Adressleiste Ihres Browsers oder am
                Schloss-Symbol im unteren Bereich Ihres Browsers.
            </p>
            <p>
                Wir bedienen uns geeigneter technischer und organisatorischer Sicherheitsmaßnahmen, um Ihre Daten
                gegen zufällige oder vorsätzliche Manipulationen, teilweisen oder vollständigen Verlust, Zerstörung
                oder gegen den unbefugten Zugriff Dritter zu schützen. Unsere Sicherheitsmaßnahmen werden entsprechend
                der technologischen Entwicklung fortlaufend verbessert.
            </p>

            <h2 id="aktualitaet">9. Aktualität und Änderung dieser Datenschutzinformation</h2>
            <p>
                Durch Weiterentwicklung unserer Angebote oder geänderte gesetzliche Vorgaben kann eine Anpassung
                dieser Datenschutzinformation erforderlich werden. Die jeweils aktuelle Fassung ist auf der Webseite
                abrufbar.
            </p>

            <h2 id="anhang">10. Anhang: Begriffserläuterungen und Rechtsgrundlagen</h2>

            <h3 id="begriffe">10.1. Begriffe</h3>
            <p>
                Im Folgenden erläutern wir einige in diesen Datenschutzhinweisen verwendete rechtliche und technische
                Begriffe.
            </p>
            <p>
                <strong>Auftragsverarbeiter:</strong><br />
                Auftragsverarbeiter sind Dienstleister, die Ihre Daten zweck- und weisungsgebunden nach unseren
                Vorgaben verarbeiten.
            </p>
            <p>
                <strong>Personenbezogene Daten:</strong><br />
                Personenbezogene Daten (Daten) sind alle Informationen, die sich auf eine identifizierte oder
                identifizierbare natürliche Person beziehen.
            </p>
            <p>
                <strong>Verarbeitung:</strong><br />
                Eine Verarbeitung personenbezogener Daten ist jeder Vorgang im Zusammenhang mit personenbezogenen
                Daten, z.B. das Erheben über ein Online-Formular, die Speicherung auf unseren Servern oder die
                Verwendung zur Kontaktaufnahme.
            </p>
            <p>
                <strong>IP-Adresse:</strong><br />
                Die IP-Adresse ist eine Nummer, die Ihr Internetanbieter Ihrem Endgerät vorübergehend oder auch
                dauerhaft zuweist. Mit einer vollständigen IP-Adresse ist es z. B. anhand von Zusatzinformationen
                Ihres Internetzugangsbetreibers im Einzelfall möglich, den Anschlussinhaber zu identifizieren.
            </p>

            <h3 id="rechtsgrundlagen">10.2. Rechtsgrundlagen</h3>
            <p>
                Die DSGVO erlaubt eine Verarbeitung personenbezogener Daten nur, wenn eine Rechtsgrundlage besteht.
                Wir sind gesetzlich verpflichtet, Ihnen die Rechtsgrundlage für die Verarbeitung Ihrer Daten
                mitzuteilen.
            </p>
            <p>
                Im Folgenden erläutern wir Ihnen die dabei verwendeten Begrifflichkeiten.
            </p>
            <table className="table">
                <thead>
                    <tr>
                        <th>Rechtsgrundlage</th>
                        <th>Bezeichnung</th>
                        <th>Erläuterung</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Art. 6 Abs. 1 lit. a) DSGVO</td>
                        <td>Einwilligung</td>
                        <td>
                            Diese Rechtsgrundlage erlaubt die Verarbeitung, wenn und soweit Sie uns eine Einwilligung
                            erteilt haben.
                        </td>
                    </tr>
                    <tr>
                        <td>Art. 6 Abs. 1 lit. b) DSGVO</td>
                        <td>Vertragserfüllung</td>
                        <td>
                            Diese Rechtsgrundlage gestattet die Verarbeitung, soweit diese zur Erfüllung eines
                            Vertrags mit Ihnen erforderlich ist, einschließlich vorvertraglicher Maßnahmen (z. B.
                            Durchführung der Nutzungsbedingungen).
                        </td>
                    </tr>
                    <tr>
                        <td>Art. 6 Abs. 1 lit. e) DSGVO</td>
                        <td>Aufgabenerfüllung</td>
                        <td>
                            Diese Rechtsgrundlage gestattet die Verarbeitung, soweit diese für die Wahrnehmung einer
                            Aufgabe erforderlich ist, die im öffentlichen Interesse liegt oder in Ausübung
                            öffentlicher Gewalt erfolgt, die uns übertragen wurde.
                        </td>
                    </tr>
                </tbody>
            </table>

            <p className="mt-4">
                <em>Stand: 09.12.2025</em>
            </p>
        </div>
    );
};

export default PrivacyPolicy;
